import { FigmaFileStructureOrigin, FigmaFileStructureStatistics, } from "@supernova-studio/model";
import { z } from "zod";
export const DTOFrameNodeStructure = z.object({
    id: z.string(),
    persistentId: z.string(),
    designSystemVersionId: z.string(),
    origin: FigmaFileStructureOrigin,
    assetsInFile: FigmaFileStructureStatistics,
});
export const DTOFrameNodeStructureListResponse = z.object({
    structures: DTOFrameNodeStructure.array(),
});
